import React, { useState, useEffect } from "react";
import { Checkbox, Spin } from "antd";
import { Button, Col, Form, Row } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { registerMerchand } from "../services/authApi";
import { toast } from "react-toastify";
import FormField from "../../../common/Form/FormField";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/Paxity.png";
import ImageLogin from "../../../assets/images/loginImg.png";
import "../utils/registration.css";
import { ArrowLeftOutlined, EyeInvisibleTwoTone, EyeTwoTone } from "@ant-design/icons";
import checkOk from "../../../assets/images/checkOk.png";
import checkNOk from "../../../assets/images/checkNok.png";
import imgsuccess from "../../../assets/images/gift.png";
import Lottie from "lottie-react";
import successAnim from "../../../assets/animations/success.json";
import OTPCodeVerifyAuth from "../../../common/otp/OTPCodeVerifyAuth";

const RegisterMerchant = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState("");
  const [submittedEmail, setSubmittedEmail] = useState("");
  const savedStep = localStorage.getItem("registerStep");
  const [step, setStep] = useState(savedStep ? Number(savedStep) : 1);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("C'est comment votre prénom"),
    lastName: Yup.string().required("Merci de renseigner votre nom"),
    email: Yup.string().email("Email invalide").required("Il nous faut votre email svp"),
    phoneNumber: Yup.string()
      .required("Téléphone requis")
      .min(8, "Numéro trop court"),

    password: Yup.string()
      .min(8, "Au moins 8 caractères")
      .matches(/[A-Z]/, "Une lettre majuscule")
      .matches(/[a-z]/, "Une lettre minuscule")
      .matches(/[0-9]/, "Un chiffre")
      .matches(/[^A-Za-z0-9]/, "Un caractère spécial")
      .when("$step", {
        is: 2,
        then: (schema) => schema.required("Mot de passe requis"),
      }),

    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Les mots de passe ne correspondent pas")
      .when("$step", {
        is: 2,
        then: (schema) => schema.required("Confirmation requise"),
      }),

    termsAccepted: Yup.boolean().oneOf(
      [true],
      "Vous devez accepter les conditions d’utilisation"
    ),
  });

  const savedForm = JSON.parse(localStorage.getItem("registerForm"));

  const initialValues = savedForm || {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    termsAccepted: false,
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    validateOnBlur: true,
    validateOnChange: true,
    context: { step },

    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        await registerMerchand(values);
        setSubmittedEmail(values.email);
        toast.success("Compte créé avec succès !");

        localStorage.removeItem("registerForm");
        localStorage.removeItem("registerStep");

        setStep(3);
      } catch (error) {
        setError(error?.response?.data || "Une erreur est survenue");
        toast.error(`Erreur d'inscription ${error?.response?.data}`);
      } finally {
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    localStorage.setItem("registerForm", JSON.stringify(formik.values));
    localStorage.setItem("registerStep", step);
  }, [formik.values, step]);

  const goToNextStep = async () => {
    const valid = await formik.validateForm();

    if (
      !valid.firstName &&
      !valid.lastName &&
      !valid.email &&
      !valid.phoneNumber
    ) {
      setStep(2);
    } else {
      formik.setTouched({
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
        termsAccepted: true,
      });
    }
  };

  const passwordChecks = {
    length: formik.values.password.length >= 8,
    uppercase: /[A-Z]/.test(formik.values.password),
    lowercase: /[a-z]/.test(formik.values.password),
    number: /[0-9]/.test(formik.values.password),
    special: /[^A-Za-z0-9]/.test(formik.values.password),
  };

  const succesRegistration = () => {
    localStorage.removeItem("registerStep");
    localStorage.removeItem("registerForm");
    setStep(1);
    navigate("/login-merchant")
  };

  return (
    <div className="d-flex">
      <div className="left-box mb-2">
        <img src={ImageLogin} alt="Logo" className="login-image" />
      </div>

      <div className="right-box">
        <div className="card-body py-2 px-md-5">
          <img src={logo} alt="Logo" />

          {(step === 1 || step === 2) && (
            <div className="auth-heading-wrapper">
              <div className="connected mt-2">Créer votre compte</div>
              <p className="texteLogin mt-2">Et explorez toutes nos fonctionnalités !</p>
            </div>
          )}

          {error && <div className="alert alert-danger">{error}</div>}

          <Form onSubmit={formik.handleSubmit} style={{ position: "relative" }}>
            {isLoading && (
              <div className="loader-create">
                <Spin size="large" tip="Traitement en cours..." />
              </div>
            )}

            <Row className="mt-0 mb-0">

              {step === 1 && (
                <>
                  <p className="steplogin mt-0">Renseigner vos informations</p>
                  <p className="texteLogin">Page 1/2</p>

                  <FormField label="Prénom" name="firstName" formik={formik} colSize={6} isRequired />
                  <FormField label="Nom" name="lastName" formik={formik} colSize={6} isRequired />
                  <FormField label="Email" name="email" formik={formik} colSize={12} isRequired />

                  <Col lg={12} className="mb-3">
                    <label className="form-label label">
                      Téléphone <span style={{ color: "red" }}>*</span>
                    </label>

                    <PhoneInput
                      country={"sn"}
                      value={formik.values.phoneNumber || ""}
                      onChange={(value) => formik.setFieldValue("phoneNumber", value || "")}
                      inputStyle={{ width: "100%" }}
                      enableSearch
                      masks={{ ci: ".. .. .. .. .." }}
                    />

                    {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                      <div className="text-danger mt-1">{formik.errors.phoneNumber}</div>
                    )}
                  </Col>

                  <Button
                    style={{ backgroundColor: "#2848FF" }}
                    type="button"
                    className="mb-2 mt-3 login-btn"
                    onClick={goToNextStep}
                  >
                    Continuer
                  </Button>
                </>
              )}

              {step === 2 && (
                <>
                  <div className="previous-page" onClick={() => setStep(1)}>
                    <ArrowLeftOutlined /> Page précédente
                  </div>

                  <p className="texteLogin">Page 2/2</p>
                  <p className="steplogin">Votre mot de passe</p>

                  <FormField
                    label="Nouveau mot de passe"
                    name="password"
                    formik={formik}
                    colSize={12}
                    type={showPassword ? "text" : "password"}
                    icon={
                      showPassword ? (
                        <EyeInvisibleTwoTone
                          twoToneColor="#ff4d4f"
                          onClick={() => setShowPassword(false)}
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        <EyeTwoTone
                          onClick={() => setShowPassword(true)}
                          style={{ cursor: "pointer" }}
                        />
                      )
                    }
                  />

                  <FormField
                    label="Confirmer le mot de passe"
                    name="confirmPassword"
                    formik={formik}
                    colSize={12}
                    type={showConfirm ? "text" : "password"}
                    icon={
                      showConfirm ? (
                        <EyeInvisibleTwoTone
                          twoToneColor="#ff4d4f"
                          onClick={() => setShowConfirm(false)}
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        <EyeTwoTone
                          onClick={() => setShowConfirm(true)}
                          style={{ cursor: "pointer" }}
                        />
                      )
                    }
                  />

                  <div className="mt-0">
                    <p className="label-t">Exigences du mot de passe :</p>
                    <ul style={{ paddingLeft: "1rem", fontSize: "14px", listStyle: "none" }}>
                      <li style={{ color: passwordChecks.uppercase && passwordChecks.lowercase ? "#2848FF" : "#C4C4C4" }}>
                        <span style={{ marginRight: "8px" }}>
                          {passwordChecks.uppercase && passwordChecks.lowercase ? <img src={checkOk} /> : <img src={checkNOk} />}
                        </span>
                        Une lettre majuscule <strong>et</strong> une minuscule
                      </li>

                      <li style={{ color: passwordChecks.number ? "#2848FF" : "#C4C4C4" }}>
                        <span style={{ marginRight: "8px" }}>
                          {passwordChecks.number ? <img src={checkOk} /> : <img src={checkNOk} />}
                        </span>
                        Un chiffre
                      </li>

                      <li style={{ color: passwordChecks.special ? "#2848FF" : "#C4C4C4" }}>
                        <span style={{ marginRight: "8px" }}>
                          {passwordChecks.special ? <img src={checkOk} /> : <img src={checkNOk} />}
                        </span>
                        Un caractère spécial (ex. !@#$%)
                      </li>
                    </ul>
                  </div>

                  <div className="terms-container mb-2">
                    <label className="terms-label">
                      <Checkbox
                        checked={formik.values.termsAccepted}
                        onChange={(e) => formik.setFieldValue("termsAccepted", e.target.checked)}
                      />
                      <span className="terms-text">
                        J’accepte la{" "}
                        <a href="/terms-and-conditions" className="terms-link">
                          politique de confidentialité et les conditions d’utilisation
                        </a>{" "}
                        de Paxity
                      </span>
                    </label>

                    {formik.touched.termsAccepted && formik.errors.termsAccepted && (
                      <div className="terms-error mt-1">{formik.errors.termsAccepted}</div>
                    )}
                  </div>

                  <Button
                    style={{ backgroundColor: "#2848FF" }}
                    type="submit"
                    className="mb-2 login-btn"
                    disabled={isLoading}
                  >
                    {isLoading ? <Spin size="small" /> : "Confirmer"}
                  </Button>
                </>
              )}

              {step === 3 && (
                <div className="mt-4">
                  <OTPCodeVerifyAuth
                    email={submittedEmail}
                    defaultStep={2}
                    skipOtpRequest={true}
                    onCancel={() => setStep(3)}
                    onVerified={() => setStep(4)}
                    isAnim={false}
                  />
                </div>
              )}

              {step === 4 && (
                <div className="text-center mt-4">
                  <Row className="mb-4">
                    <Col lg={2}></Col>

                    <Col lg={8}>
                      <Lottie
                        animationData={successAnim}
                        loop
                        autoplay
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                        }}
                      />

                      <div className="text-center mt-4 mb-4" style={{ fontSize: "22px", fontWeight: "bold" }}>
                        <img src={imgsuccess} className="mt-4 mb-4" />
                        <br />
                        Félicitations, votre compte a été créé avec succès !
                      </div>

                      <p className="text-muted text-center mt-4 mb-4" style={{ maxWidth: 400, margin: "0 auto 20px" }}>
                        Heureux de vous compter parmi nous. <br />
                        Maintenant vous pouvez accéder à votre compte avec votre mail et mot de passe.
                      </p>

                      <Button
                        type="primary"
                        onClick={succesRegistration}
                        className="mb-2 mt-3 login-btn"
                      >
                        Se connecter
                      </Button>
                    </Col>

                    <Col lg={2}></Col>
                  </Row>
                </div>
              )}

            </Row>
          </Form>

          {(step === 1 || step === 2) && (
            <div className="text-center mb-1 mt-0">
              J'ai déjà un compte,{" "}
              <a
                style={{ color: "#2848FF" }}
                href="/login-merchant"
                onClick={(e) => {
                  e.preventDefault();
                  succesRegistration();
                }}
              >
                Se connecter
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegisterMerchant;
